export {
  Namespaces,
  getObelixFriendlyLocale,
  includeDefaultNamespaces,
} from "./ObelixProvider";
export { i18n, initI18n, defaultNS, namespaces } from "./i18n";
export { useTranslation } from "react-i18next";

/**
 * Minimal i18n document-language service.
 *
 * The rendered document's `lang` attribute must reflect the active locale so
 * screen readers pick the correct pronunciation rules. Locale codes on this
 * site are of the form `<lang>-<REGION>` (e.g. `en-US`, `pt-BR`); the BCP 47
 * primary language subtag is what we expose on `<html lang>`.
 */

const SUPPORTED_PRIMARY_LANGUAGES = [
  "en",
  "de",
  "es",
  "fr",
  "it",
  "ja",
  "ko",
  "pt",
] as const;

/** Map a site locale (e.g. `es-MX`) to its BCP 47 primary language (`es`). */
export const localeToBcp47 = (locale: string): string => {
  const primary = locale.split("-")[0]?.toLowerCase() ?? "";
  return (SUPPORTED_PRIMARY_LANGUAGES as readonly string[]).includes(primary)
    ? primary
    : primary;
};

/** Apply the active locale's language to the document element. */
export const setDocumentLanguage = (locale: string): void => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = localeToBcp47(locale);
};
